import { render, staticRenderFns } from "./contract-history.component.vue?vue&type=template&id=38764433&scoped=true&"
import script from "./contract-history.component.vue?vue&type=script&lang=ts&"
export * from "./contract-history.component.vue?vue&type=script&lang=ts&"
import style0 from "./contract-history.component.vue?vue&type=style&index=0&id=38764433&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38764433",
  null
  
)

export default component.exports